import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'tm-dynamic-documents',
  templateUrl: './tm-dynamic-documents.component.html',
  styleUrls: ['./tm-dynamic-documents.component.scss']
})
export class TmDynamicDocumentsComponent implements OnInit {

  @Input() masters;
  @Input() form_group;
  @Input() section;
  @Input() field;
  @Input() disabled_fields;

  @Input() verificationRequired;
  @Input() callbackFn;
  @Input() alertId;
  @Input() verification_status_list;
  @Input() disabled;

  constructor() { }

  ngOnInit(): void {
    this.prepareDocs()
  }
  prepareDocs() {
    try {
      for (let i = 0; i < this.masters[this.field.masterPropName].length; i++) {
        let element = this.masters[this.field.masterPropName][i];
        if (element['UIValidationObjStruct'] && element['UIValidationObjStruct']['supportedFileTypes']) {
          element['UIValidationObjStruct']['supportedFileTypes'].value = eval(element['UIValidationObjStruct']['supportedFileTypes'].value)

        }
      }
    }
    catch (err) {

    }
  }

}
